import {gql} from '@apollo/client';
import {FRAGMENT_CLIENT_LIST} from '../Client/graphql';

export const QUERY_BLOCK_LIST = gql`
  query BlockList($forumId: ID) {
    blockList(forum: $forumId) {
      id
      client {
        ...ClientList
      }
    }
  }
  ${FRAGMENT_CLIENT_LIST}
`;

export const MUTATION_BLOCK_SAVE = gql`
  mutation BlockSave($input: BlockSaveInput!) {
    blockSave(input: $input) {
      obj {
        id
        client {
          ...ClientList
        }
      }
    }
  }
  ${FRAGMENT_CLIENT_LIST}
`;

export const MUTATION_BLOCK_DELETE = gql`
  mutation BlockDelete($input: BlockDeleteInput!) {
    blockDelete(input: $input) {
      obj {
        id
      }
    }
  }
`;
